export default "__VITE_ASSET__BGeibCRd__"